// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".infoBox[data-v-37d0ab30] {\n  display: flex;\n  align-items: center;\n}\n.infoBox .info[data-v-37d0ab30] {\n  display: flex;\n  flex-direction: column;\n}\n.name[data-v-37d0ab30] {\n  font-weight: bold;\n  font-size: 18px;\n}\n[data-v-37d0ab30] .ant-col {\n  padding-right: 30rpx;\n}", ""]);
// Exports
module.exports = exports;
